import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  actionLabelCell: {
    maxWidth: '20rem'
  },
  modeCell: {
    verticalAlign: 'middle',
    width: '12rem'
  },
  modeCellDirty: {
    outline: `1px solid ${theme.vars.palette.warning.main}`,
    outlineOffset: '-.125rem'
  },
  hostExclusionControls: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'stretch'
    }
  },
  hostExclusionHosts: {
    flex: '2 1 0',
    minWidth: 0
  },
  hostExclusionSelect: {
    flex: '1 1 0',
    minWidth: 0
  },
  hostExclusionTags: {
    flex: '2 1 0',
    minWidth: 0
  },
  hostExclusionUpload: {
    display: 'flex',
    flex: '0 0 auto',
    flexDirection: 'column'
  },
  hostExclusionUploadLabel: {
    visibility: 'hidden',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  tableContainer: {
    thead: {
      th: {
        textTransform: 'uppercase',
        backgroundColor: theme.vars.palette.background.default,
        padding: theme.spacing(1, 2)
      }
    }
  }
}));

export default useStyles;
